export default __webpack_public_path__ + "static/media/a7.740c84c1.png";